import { render, staticRenderFns } from "./DataTableGroupEditor.vue?vue&type=template&id=5a901b1c&"
import script from "./DataTableGroupEditor.vue?vue&type=script&lang=js&"
export * from "./DataTableGroupEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports